import { render, staticRenderFns } from "./PscDashboard.vue?vue&type=template&id=082f68d2&scoped=true&"
import script from "./PscDashboard.vue?vue&type=script&lang=js&"
export * from "./PscDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PscDashboard.vue?vue&type=style&index=0&id=082f68d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082f68d2",
  null
  
)

export default component.exports